import { selector } from "recoil";
import { appTheme, dates, filters, layout, url, token, reportID, data } from "./atoms";

export const appThemeSelector = selector({
  key: "appThemeSelector",
  get: ({ get }: { get: Function }) => get(appTheme),
  set: ({ set }: { set: Function }, newValue: string) => set(appTheme, newValue)
});

export const urlSelector = selector({
  key: "urlSelector",
  get: ({ get }: { get: Function }) => get(url),
  set: ({ set }: { set: Function }, newValue: string) => set(url, newValue)
});

export const filtersSelector = selector({
  key: "filtersSelector",
  get: ({ get }: { get: Function }) => get(filters),
  set: ({ set }: { set: Function }, newValue: string) => set(filters, newValue)
});

export const layoutSelector = selector({
  key: "layoutSelector",
  get: ({ get }: { get: Function }) => get(layout),
  set: ({ set }: { set: Function }, newValue: string) => set(layout, newValue)
});

export const datesSelector = selector({
  key: "datesSelector",
  get: ({ get }: { get: Function }) => get(dates),
  set: ({ set }: { set: Function }, newValue: string) => set(dates, newValue)
});

export const tokenSelector = selector({
  key: "tokenSelector",
  get: ({ get }: { get: Function }) => get(token),
  set: ({ set }: { set: Function }, newValue: string) => set(token, newValue)
});

export const reportIDSelector = selector({
  key: "reportIDSelector",
  get: ({ get }: { get: Function }) => get(reportID),
  set: ({ set }: { set: Function }, newValue: string) => set(reportID, newValue)
});

export const dataSelector = selector({
  key: "dataSelector",
  get: ({ get }: { get: Function }) => get(data),
  set: ({ set }: { set: Function }, newValue: string) => set(data, newValue)
});
